import { Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import Metre from "../../Math/Units/Metric/Metre";
import Millimetre from "../../Math/Units/Metric/Millimetre";
import { DataRow, DataRowTextValue } from "../DataRow";
import InvoiceTableBlankSpace from "../InvoiceTableBlankSpace";
import { PageWrapper, styles, tableStyles } from "../SmartTitanProjektPDF";

export function GermanyAussereDruckNachweisUebertragungslaenge({ data }) {
  const { t } = useTranslation("translation");
  let itemIndex = 1;

  return (
    <PageWrapper Deckblatt={data.Deckblatt}>
      <View>
        {/* Nachweis der Mantelreibung mit Erfahrungswerten */}
        <Text style={styles.sectionSubText}>{t("aeussre.transmissionCheckboxText_pdf")}</Text>
        <View style={tableStyles.tableContainer}>
          {/* Druckfestigkeit Verpressmörtel/Beton */}
          <DataRow
            item={{
              title: t("aeussre.compressiveStrengthConcrete"),
              value:
                data.Germany.Aussere.NachweisUebertragungslaenge
                  .druckfestigkeitVerpressmoertelBeton,
              // f_{c,k}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}f_{c,k}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}f_{c,k}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}f_{c,k}",
                height: 9,
                width: 12,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              valueUnit: "N/mm²", //<NewtonDividedByMillimetreSquared />,
            }}
          />

          {/* Betonzugfestigkeit */}
          <DataRow
            item={{
              title: t("aeussre.concreteTensileStrength"),
              value: data.Germany.Aussere.NachweisUebertragungslaenge.betonzugfestigkeit,
              // f_{ctk 0,05}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}f_{ctk&space;0,05}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}f_{ctk&space;0,05}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}f_{ctk&space;0,05}",
                height: 9,
                width: 24,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: "N/mm²", //<NewtonDividedByMillimetreSquared />,
            }}
          />

          {/* Teilsicherheitsbeiwert */}
          <DataRow
            item={{
              title: t("aeussre.partialSafetyFactor"),
              value: data.Germany.Aussere.NachweisUebertragungslaenge.teilsicherheitsbeiwert,
              // \gamma_c
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\gamma_c
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma_c
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\gamma_c",
                height: 6,
                width: 7,
              },
              valueScale: 1,
              itemIndex: itemIndex++,
            }}
          />
          {/* GoodBondConditions */}
          <DataRowTextValue
            item={{
              title: t("aeussre.GoodBondConditions"),
              value:
                data.Germany.Aussere.NachweisUebertragungslaenge.verbundbedingungenGut === 1
                  ? t("aeussre.GoodBondConditions_well")
                  : t("aeussre.GoodBondConditions_moderate"),
              itemIndex: itemIndex++,
            }}
          />
          {/* GoodBondConditions */}
          <DataRow
            item={{
              value: data.Germany.Aussere.NachweisUebertragungslaenge.verbundbedingungenGut,
              // \eta_{1}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\eta_{1}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\eta_{1}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\eta_{1}",
                height: 6,
                width: 7,
              },
              valueScale: 1,
              itemIndex: itemIndex++,
            }}
          />

          {/* Beiwert */}
          <DataRow
            item={{
              title: t("aeussre.bondConditions"),
              value: data.Germany.Aussere.NachweisUebertragungslaenge.beiwert,
              // \eta_{2}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}\eta_{2}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\eta_{2}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}\\eta_{2}",
                height: 6,
                width: 7,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
            }}
          />

          {/* Verbundfestigkeit */}
          <DataRow
            item={{
              title: t("aeussre.bondStrength"),
              value: data.Germany.Aussere.NachweisUebertragungslaenge.verbundfestigkeit,
              // f_{bd}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}f_{bd}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}f_{bd}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}f_{bd}",
                height: 8,
                width: 10,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: "N/mm²", //<NewtonDividedByMillimetreSquared />,
              // f_{bd}=2,25\cdot \eta_1\cdot \eta_2\cdot \frac{f_{ctk,0,05}}{\gamma_c}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}f_{bd}=2,25\cdot&space;\eta_1\cdot&space;\eta_2\cdot&space;\frac{f_{ctk,0,05}}{\gamma_c}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}f_{bd}=2,25\\cdot&space;\\eta_1\\cdot&space;\\eta_2\\cdot&space;\\frac{f_{ctk,0,05}}{\\gamma_c}
              formulaImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}f_{bd}=2,25\\cdot&space;\\eta_1\\cdot&space;\\eta_2\\cdot&space;\\frac{f_{ctk,0,05}}{\\gamma_c}",
                height: 13,
                width: 96,
              },
            }}
          />

          {/* Außendurchmesser Stahltragglied */}
          <DataRow
            item={{
              title: t("aeussre.outerDiameter"),
              value:
                data.Germany.Aussere.NachweisUebertragungslaenge.außendurchmesserStahltragglied,
              // D_a
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}D_a
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}D_a
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}D_a",
                height: 7,
                width: 10,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Millimetre />,
            }}
          />

          {/* Übertragungslänge */}
          <DataRow
            item={{
              title: t("aeussre.transmissionLength"),
              value: data.Germany.Aussere.NachweisUebertragungslaenge.uebertragungslaenge,
              // l_b
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}l_b
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_b
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_b",
                height: 7,
                width: 5,
              },
              valueScale: 2,
              itemIndex: itemIndex++,
              valueUnit: <Metre />,
              // l_b=\frac{F_d}{\pi\cdot D_a\cdot f_{bd}}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}l_b=\frac{F_d}{\pi\cdot&space;D_a\cdot&space;f_{bd}}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_b=\\frac{F_d}{\\pi\\cdot&space;D_a\\cdot&space;f_{bd}}
              formulaImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}l_b=\\frac{F_d}{\\pi\\cdot&space;D_a\\cdot&space;f_{bd}}",
                height: 12,
                width: 43,
              },
            }}
          />
          <InvoiceTableBlankSpace rowsCount={25 - itemIndex} />
        </View>
      </View>
    </PageWrapper>
  );
}
